import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import AddButton from "../buttons/button";
import DeleteIcon from "../../assets/icons/delete-icon";
import errorToast from "../helper-components/error-toast";

const ReturnBillItemsSection = ({
  setSelectedItem,
  selectedItem,
  disabled,
}) => {
  // const [isLoadingOverlay, setIsLoadingOverlay] = useState(false);

  const [heading, setHeading] = useState([]);

  // const [heading] = useState([
  //   { label: "S No.", value: "sl_no" },
  //   { label: "Linked Invoice No.", value: "linked_invoice_number" },
  //   { label: "Item code", value: "item_code" },
  //   { label: "Generic Name", value: "item_Generic_name" },
  //   { label: "Product Name", value: "item_name" },
  //   { label: "Open Qty", value: "item_open_quantity" },
  //   { label: "Qty", value: "quantity" },
  //   { label: "Free Qty", value: "item_free_quantity" },
  //   { label: "UOM", value: "item_uom" },
  //   { label: "Batch No.", value: "item_batch_number" },
  //   { label: "Exp. Date", value: "item_exp_date" },
  //   { label: "Loc.", value: "item_rack_location" },
  //   { label: "Mfg by.", value: "item_manufacturer_name" },
  //   { label: "SCH", value: "item_schedule" },
  //   { label: "HSN", value: "item_hsn" },
  //   { label: "Unit MRP", value: "item_unit_price" },
  //   { label: "MRP", value: "item_pack_price" },
  //   { label: "Price (₹)", value: "item_price_wiithout_tax" },
  //   { label: "Disc. (₹)", value: "item_discount_amount" },
  //   { label: "Disc. (%)", value: "item_discount_percentage" },
  //   { label: "Tax (₹)", value: "item_tax_amount" },
  //   { label: "Tax %", value: "item_gst" },
  //   { label: "Final Price (₹)", value: "item_final_price" },
  //   { label: "Total (₹)", value: "item_total_amount" },
  //   {
  //     alignment: "center",
  //     enabled: true,
  //     label: "Clear All",
  //     minWidth: "10",
  //     value: "clear_all",
  //   },
  // ]);

  const { values, setFieldValue } = useFormikContext();
  useEffect(() => {
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const billingData = parsed.find((obj) => obj?.return_bill_create);
      if (billingData?.return_bill_create) {
        setHeading(billingData.return_bill_create);
      }
    }
  }, []);

  const removeRow = (rowIndex, type = "") => {
    let updatedData = [...values.data];

    if (type === "all") {
      updatedData = [];
    } else {
      updatedData.splice(rowIndex, 1);
    }
    setFieldValue("data", updatedData);
    const icn_total_gst = updatedData.reduce(
      (total, item) => total + parseFloat(item?.item_tax_amount || 0),
      0
    );

    const icn_total_discount = updatedData.reduce(
      (total, item) => total + parseFloat(item?.item_discount_amount || 0),
      0
    );

    const icn_sub_total = updatedData.reduce(
      (subtotal, item) => subtotal + parseFloat(item?.item_unit_price || 0),
      0
    );

    const icn_total_amount = updatedData.reduce(
      (total, item) => total + parseFloat(item?.item_total_amount || 0),
      0
    );

    const rounded_total = Math.round(icn_total_amount);
    const roundoff = (rounded_total - icn_total_amount).toFixed(2);
    setFieldValue("icn_total_gst", icn_total_gst.toFixed(2));
    setFieldValue("icn_total_discount", icn_total_discount.toFixed(2));
    setFieldValue("icn_sub_total", icn_sub_total.toFixed(2));
    setFieldValue("icn_total_amount", rounded_total.toFixed(2));
    setFieldValue("icn_round_off_value", roundoff);
    setFieldValue("icn_invoice_discount", 0);
    setFieldValue("icn_invoice_discount_percentage", 0);
    setFieldValue("icn_is_invoice_dis_percentage ", true);
    setFieldValue("header_inv_dis_per ", 0);
  };

  const handleQuantityChange = (updatedQty, rowIndex) => {
    const updatedData = values.data?.map((row, index) => {
      if (index === rowIndex) {
        const updatedQuantity = parseFloat(updatedQty) || 0;

        const totalAmountBeforeTax =
          updatedQuantity * parseFloat(row.item_unit_price || 0);

        const itemDiscountAmount = (
          (totalAmountBeforeTax *
            parseFloat(row.item_discount_percentage || 0)) /
          100
        ).toFixed(2);
        const taxableAmount =
          totalAmountBeforeTax - parseFloat(itemDiscountAmount);
        const gstPercentage = parseFloat(row.item_gst || 0);
        const taxAmount =
          taxableAmount - taxableAmount * (100 / (100 + gstPercentage));
        const itemPriceWithoutTax = (taxableAmount - taxAmount).toFixed(2);
        const itemTaxAmount = taxAmount.toFixed(2);
        const itemSGST = (taxAmount / 2).toFixed(2);
        const itemCGST = (taxAmount / 2).toFixed(2);
        const itemIGST = 0;
        const itemFinalPrice = (taxableAmount / updatedQuantity || 0).toFixed(
          2
        );
        const itemTotalAmount = taxableAmount.toFixed(2);

        return {
          ...row,
          quantity: updatedQuantity,
          item_discount_amount: itemDiscountAmount,
          item_tax_amount: itemTaxAmount,
          item_price_wiithout_tax: itemPriceWithoutTax,
          item_sgst: itemSGST,
          item_cgst: itemCGST,
          item_igst: itemIGST,
          item_final_price: itemFinalPrice,
          item_total_amount: itemTotalAmount,
        };
      }
      return row;
    });

    setFieldValue("data", updatedData);

    const icn_total_gst = updatedData.reduce(
      (total, item) => total + parseFloat(item?.item_tax_amount || 0),
      0
    );

    const icn_total_discount = updatedData.reduce(
      (total, item) => total + parseFloat(item?.item_discount_amount || 0),
      0
    );

    const icn_sub_total = updatedData.reduce(
      (subtotal, item) =>
        subtotal +
        parseFloat(item?.item_unit_price || 0) *
          parseFloat(item?.quantity || 0),
      0
    );

    const icn_total_amount = updatedData.reduce(
      (total, item) => total + parseFloat(item?.item_total_amount || 0),
      0
    );

    const rounded_total = Math.round(icn_total_amount);
    const roundoff = (rounded_total - icn_total_amount).toFixed(2);

    setFieldValue("icn_total_gst", icn_total_gst.toFixed(2));
    setFieldValue("icn_total_discount", icn_total_discount.toFixed(2));
    setFieldValue("icn_sub_total", icn_sub_total.toFixed(2));
    setFieldValue("icn_total_amount", rounded_total.toFixed(2));
    setFieldValue("icn_round_off_value", roundoff);
    setFieldValue("icn_invoice_discount", 0);
    setFieldValue("icn_invoice_discount_percentage", 0);
    setFieldValue("icn_is_invoice_dis_percentage ", true);
    setFieldValue("header_inv_dis_per ", 0);
  };

  return (
    <div
      style={{
        maxHeight: `calc(100% - 8.5rem)`, // Limit the container height
        height: "auto", // Let it grow naturally to fit its content
      }}
      className={`border border-[var(--create-table-main-border)] border-1 border-radius px-3 pb-3`}
    >
      <div
        style={{
          maxHeight: `100%`,
          minHeight: `5rem`,
        }}
        className={`tab-container border-radius mt-[1rem]`}
      >
        <table className="w-full border-collapse mt-0">
          <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
            <tr className="relative h-[50px]">
              {heading
                ?.filter((heading) => heading?.enabled !== false)
                ?.map((heading, index) => (
                  <th
                    style={{ minWidth: `${heading?.minWidth}px` }}
                    key={index}
                    className={`px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                  >
                    {heading?.value === "clear_all" ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent:
                            heading?.alignment === "right"
                              ? "flex-end"
                              : heading?.alignment === "center"
                              ? "center"
                              : "flex-start",
                          width: "100%", // Ensure the div takes full width of the th
                        }}
                      >
                        {!disabled && (
                          <AddButton
                            type="button"
                            onclkFn={() => {
                              if (values?.data?.length > 0) {
                                removeRow(0, "all");
                              }
                            }}
                            prefixIcon={false}
                            text={"Clear All"}
                            className="flex items-center px-[10px] py-[10px] h-[20px] whitespace-nowrap border-radius gap-[8px]
                 bg-[var(--create-table-clearAll-bg)] 
                 cursor-pointer 
                 text-[var(--create-table-clearAll-color)] 
                 text-[length:var(--create-table-clearAll-fs)] 
                 font-[var(--create-table-clearAll-fw)] 
                 border-2 border-[var(--create-table-clearAll-border)] 
                 hover:bg-[var(--create-table-clearAll-bg)]"
                          />
                        )}
                      </div>
                    ) : (
                      <div
                        className="flex items-center gap-2 w-full"
                        style={{
                          justifyContent:
                            heading?.alignment === "right"
                              ? "flex-end"
                              : heading?.alignment === "center"
                              ? "center"
                              : "flex-start",
                        }}
                      >
                        {heading?.label}
                      </div>
                    )}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody className="h-full">
            {values?.data?.map((rowData, rowIndex) => (
              <tr
                className={`hover:bg-[var(--create-table-row-hover-bg)] ${
                  rowIndex % 2 === 0
                    ? " bg-[var(--create-table-row-alt-bg)]"
                    : " bg-[var(--create-table-row-bg)]"
                }   h-[50px] `}
                key={rowIndex}
              >
                {heading
                  ?.filter((heading) => heading?.enabled !== false)
                  ?.map((heading, index) => {
                    return (
                      <td
                        style={{
                          minWidth: `${heading?.minWidth}px`,
                          textAlign: heading?.alignment, // Keep textAlign for normal text cells
                        }}
                        key={index}
                        className="border-b border-[var(--create-table-border)] px-[8px] text-left text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)] text-[var(--create-table-row-fg-color)] whitespace-nowrap cursor-pointer"
                      >
                        {heading?.value === "quantity" ? (
                          <input
                            disabled={disabled}
                            type="number"
                            value={rowData.quantity || ""}
                            max={rowData?.item_open_quantity || ""}
                            onChange={(e) => {
                              const enteredQty =
                                parseFloat(e.target.value) || 0;
                              const maxQty = parseFloat(
                                rowData?.item_open_quantity || 0
                              );
                              const finalQty =
                                enteredQty > maxQty ? maxQty : enteredQty;
                              if (enteredQty > maxQty) {
                                errorToast(
                                  `Can't Exceed Maximum Quanity ${maxQty}`
                                );
                              }
                              handleQuantityChange(finalQty, rowIndex);
                            }}
                            onKeyDown={(e) => {
                              if (["Enter"].includes(e.key)) {
                                e.preventDefault(); // prevent default behavior for Enter and Tab

                                const enteredQty =
                                  parseFloat(e.target.value) || 0;
                                const maxQty = parseFloat(
                                  rowData?.item_open_quantity || 0
                                );
                                const finalQty =
                                  enteredQty > maxQty ? maxQty : enteredQty;

                                if (enteredQty > maxQty) {
                                  errorToast(
                                    `Can't Exceed Maximum Quantity ${maxQty}`
                                  );
                                }

                                handleQuantityChange(finalQty, rowIndex);
                              }
                            }}
                        
                            className="min-h-[33px] px-2 border border-[var(--pay-met-input-border)] focus:outline-none bg-[var(--pay-met-input-bg)] text-[var(--pay-met-val-color)] text-[length:var(--pay-met-val-fs)] font-[var(--pay-met-val-fw)] border-radius input-field-no-spin-buttons w-[4rem]"
                          />
                        ) : heading.value === "clear_all" ? (
                          <button
                            type="button"
                            onClick={() => {
                              removeRow(rowIndex, "");
                            }}
                            style={{
                              display: "flex",
                              justifyContent:
                                heading?.alignment === "right"
                                  ? "flex-end"
                                  : heading?.alignment === "center"
                                  ? "center"
                                  : "flex-start",
                              width: "100%", // Take full width of the td
                            }}
                          >
                            {!disabled && (
                              <DeleteIcon className="cursor-pointer text-red-500" />
                            )}
                          </button>
                        ) : (
                          rowData[heading.value] ?? "--"
                        )}
                      </td>
                    );
                  })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReturnBillItemsSection;
